import React from 'react';

import { playSound } from 'src/modules/soundHandler';

import styles from './SquareButton.module.scss';

interface SquareButtonPropsInterface {
  image?: any;
  text: string;
  colorPreset?: 'white' | 'red' | 'blue' | 'green' | 'yellow' | 'lightblue';
  noHeight?: boolean;
  onClick?: () => any;
  Icon?: any; // TODO: Type correctly
  [key: string]: any; // Any other props
}

const SquareButton = ({
  image,
  text,
  colorPreset = 'blue',
  noHeight = false,
  onClick,
  Icon,
  ...otherProps
}: SquareButtonPropsInterface) => {
  const buttonClick = () => {
    if (onClick) {
      onClick();
      playSound('selectClick');
    }
  };

  return (
    <button
      style={noHeight ? { height: 'auto' } : {}}
      className={[styles.SquareButton, styles[colorPreset]]
        .filter(Boolean)
        .join(' ')}
      onClick={buttonClick}
      {...otherProps}
    >
      {Icon && (
        <div className={styles['icon-holder']}>
          <Icon />
        </div>
      )}
      <div className={styles['image-holder']}>
        {image && <img src={image} />}
      </div>
      <div className={styles['text-holder']}>{text}</div>
      {Icon && (
        <div className={styles['background-icon']} aria-hidden="true">
          <Icon fontSize="inherit" />
        </div>
      )}
    </button>
  );
};

export default SquareButton;
